import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { RiMenu4Line } from "react-icons/ri";
import { LiaBlogSolid, LiaImagesSolid } from "react-icons/lia";
import { MdDashboardCustomize } from "react-icons/md";
import { PiArticleNyTimesBold } from "react-icons/pi";
import { AiOutlineAppstore } from "react-icons/ai";
import { BiCube } from "react-icons/bi";
import { FaCubes, FaDownload, FaEnvelope, FaHome, FaUserAlt, FaUsers } from "react-icons/fa";
import { RiInformationLine } from "react-icons/ri";
import logo from '../../assets/logo.png';

const Sidebar = () => {
  const navigate = useNavigate();
  const path = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleLogout = () => {
    navigate('/login');
  };

  return (
    <div className='lg:w-[20%] h-[100vh] flex flex-col'>
      {/* Desktop Sidebar */}
      <div className="lg:contents hidden relative flex-shrink-0" aria-label="Sidebar">
        <div className="overflow-y-auto py-4 px-3 bg-[#101828] shadow-xl flex flex-col h-full">
          <div className="flex items-center">
            <img className='w-16 h-auto' src={logo} alt="logo" />
            <div className="text-xl font-bold tracking-wider ml-4 bg-gradient-to-r from-[#f86464] to-[#78c5ee] bg-clip-text text-transparent">
              BBSR Services
            </div>
          </div>

          <ul className="flex flex-col flex-grow">
            {/* Dashboard */}
            <li>
              <div
                onClick={() => navigate('/dashboard')}
                className={`${path?.pathname === '/dashboard'
                  ? "bg-gray-400 font-semibold"
                  : "text-[#f1e7d6] hover:text-[#a3a231]"}
                  flex items-center cursor-pointer p-3 text-lg tracking-wider font-medium rounded-lg mt-4`}>
                <MdDashboardCustomize size={28} className='mr-4' />
                <span>Dashboard</span>
              </div>
            </li>

            <li>
              <div
                onClick={() => navigate('/inquiry')}
                className={`${path?.pathname === '/inquiry'
                  ? "bg-gray-400 font-semibold"
                  : "text-[#f1e7d6] hover:text-[#a3a231]"}
                  flex items-center cursor-pointer p-3 text-lg tracking-wider font-medium rounded-lg mt-4`}>
                <FaEnvelope size={28} className='mr-4' />
                <span>Inquiry From</span>
              </div>
            </li>
            <li>
              <div
                onClick={() => navigate('/associate')}
                className={`${path?.pathname === '/associate'
                  ? "bg-gray-400 font-semibold"
                  : "text-[#f1e7d6] hover:text-[#a3a231]"}
                  flex items-center cursor-pointer p-3 text-lg tracking-wider font-medium rounded-lg mt-4`}>
                <FaUsers size={28} className='mr-4' />
                <span>Associate</span>
              </div>
            </li>

            {/* Banner */}
            <li>
              <div
                onClick={() => navigate('/banner')}
                className={`${path?.pathname === '/banner'
                  ? "bg-gray-400 font-semibold"
                  : "text-[#f1e7d6] hover:text-[#a3a231]"}
                  flex items-center cursor-pointer p-3 text-lg tracking-wider font-medium rounded-lg mt-4`}>
                <LiaImagesSolid size={28} className='mr-4' />
                <span>Banner</span>
              </div>
            </li>

            {/* Blogs */}
            <li>
              <div
                onClick={() => navigate('/blogs')}
                className={`${path?.pathname === '/blogs'
                  ? "bg-gray-400 font-semibold"
                  : "text-[#f1e7d6] hover:text-[#a3a231]"}
                  flex items-center cursor-pointer p-3 text-lg tracking-wider font-medium rounded-lg mt-4`}>
                <LiaBlogSolid size={28} className='mr-4' />
                <span>Blogs</span>
              </div>
            </li>

            {/* Articles */}
            <li>
              <div
                onClick={() => navigate('/articles')}
                className={`${path?.pathname === '/articles'
                  ? "bg-gray-400 font-semibold"
                  : "text-[#f1e7d6] hover:text-[#a3a231]"}
                  flex items-center cursor-pointer p-3 text-lg tracking-wider font-medium rounded-lg mt-4`}>
                <PiArticleNyTimesBold size={28} className='mr-4' />
                <span>Articles</span>
              </div>
            </li>

            {/* Services */}
            <li>
              <div
                onClick={() => navigate('/services')}
                className={`${path?.pathname === '/services'
                  ? "bg-gray-400 font-semibold"
                  : "text-[#f1e7d6] hover:text-[#a3a231]"}
                  flex items-center cursor-pointer p-3 text-lg tracking-wider font-medium rounded-lg mt-4`}>
                <AiOutlineAppstore size={28} className='mr-4' />
                <span>Services</span>
              </div>
            </li>

            {/* Subservices */}
            <li>
              <div
                onClick={() => navigate('/subservices')}
                className={`${path?.pathname === '/subservices'
                  ? "bg-gray-400 font-semibold"
                  : "text-[#f1e7d6] hover:text-[#a3a231]"}
                  flex items-center cursor-pointer p-3 text-lg tracking-wider font-medium rounded-lg mt-4`}>
                <BiCube size={28} className='mr-4' />
                <span>Subservices</span>
              </div>
            </li>

            {/* 🆕 Sub-Subservice */}
            <li>
              <div
                onClick={() => navigate('/subsubservice')}
                className={`${path?.pathname === '/subsubservice'
                  ? "bg-gray-400 font-semibold"
                  : "text-[#f1e7d6] hover:text-[#a3a231]"}
                  flex items-center cursor-pointer p-3 text-lg tracking-wider font-medium rounded-lg mt-4`}>
                <FaCubes size={26} className='mr-4' />
                <span>Sub-Subservice</span>
              </div>
            </li>
            <li>
              <div
                onClick={() => navigate("/download")}
                className={`${path?.pathname === "/download"
                  ? "bg-gray-400 text-black font-semibold"
                  : "text-[#f1e7d6] hover:text-[#a3a231]"
                  } flex items-center gap-3 cursor-pointer p-3 text-lg tracking-wider font-medium rounded-lg mt-4 transition-colors duration-200`}
              >
                <FaDownload size={22} className="flex-shrink-0" />
                <span className="leading-none">PDF Upload</span>
              </div>

            </li>

            {/* 🆕 Homepage */}
            <li>
              <div
                onClick={() => navigate('/homepage')}
                className={`${path?.pathname === '/homepage'
                  ? "bg-gray-400 font-semibold"
                  : "text-[#f1e7d6] hover:text-[#a3a231]"}
                  flex items-center cursor-pointer p-3 text-lg tracking-wider font-medium rounded-lg mt-4`}>
                <FaHome size={26} className='mr-4' />
                <span>Homepage</span>
              </div>
            </li>

            {/* 🆕 About Page */}
            <li>
              <div
                onClick={() => navigate('/aboutpage')}
                className={`${path?.pathname === '/aboutpage'
                  ? "bg-gray-400 font-semibold"
                  : "text-[#f1e7d6] hover:text-[#a3a231]"}
                  flex items-center cursor-pointer p-3 text-lg tracking-wider font-medium rounded-lg mt-4`}>
                <RiInformationLine size={26} className='mr-4' />
                <span>About Page</span>
              </div>
            </li>

            <li>
              <div
                onClick={() => navigate('/our-client')}
                className={`${path?.pathname === '/our-client'
                  ? "bg-gray-400 font-semibold"
                  : "text-[#f1e7d6] hover:text-[#a3a231]"}
                  flex items-center cursor-pointer p-3 text-lg tracking-wider font-medium rounded-lg mt-4`}>
                <FaUsers size={28} className='mr-4' />
                <span>Our Client</span>
              </div>
            </li>

            {/* 🆕 Profile */}
            <li>
              <div
                onClick={() => navigate('/profile')}
                className={`${path?.pathname === '/profile'
                  ? "bg-gray-400 font-semibold"
                  : "text-[#f1e7d6] hover:text-[#a3a231]"}
                  flex items-center cursor-pointer p-3 text-lg tracking-wider font-medium rounded-lg mt-4`}>
                <FaUserAlt size={26} className='mr-4' />
                <span>Profile</span>
              </div>
            </li>
          </ul>

          {/* <button
            onClick={handleLogout}
            className="mt-4 bg-gradient-to-r from-[#FF3131] to-[#ff9301] text-white font-semibold tracking-wider py-2 px-4 rounded-md text-center hover:bg-red-600 transition duration-300 ease-in-out">
            Logout
          </button> */}
        </div>
      </div>

      {/* Mobile Sidebar */}
      <div className='block lg:hidden'>
        <button
          onClick={() => setIsSidebarOpen(true)}
          className='absolute ml-6 mt-7 bg-[#e8e8fc] rounded-md p-2 text-white'>
          <RiMenu4Line size={28} color='black' />
        </button>

        <AnimatePresence>
          {isSidebarOpen &&
            <motion.div
              className='h-full w-[50%] absolute'
              initial={{ opacity: 0, x: '-100%' }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: '-100%' }}
              transition={{ duration: 0.3 }}>
              <div className="overflow-y-auto py-4 px-3 bg-[#101828] shadow-xl h-screen relative z-20">
                <span
                  onClick={() => setIsSidebarOpen(false)}
                  className='text-2xl absolute top-4 right-5 text-[#FF8607]'>
                  x
                </span>

                <button onClick={() => setIsSidebarOpen(false)}>
                  <div className="flex items-center">
                    <img className='w-16 h-auto' src={logo} alt="logo" />
                  </div>
                </button>

                <ul>
                  {[
                    { path: '/dashboard', label: 'Dashboard', icon: <MdDashboardCustomize size={16} /> },
                    { path: '/inquiry', label: 'Inquiry Form', icon: <FaEnvelope size={16} /> },
                      { path: '/associate', label: 'Associate', icon: <FaUsers size={16} /> },
                    { path: '/blogs', label: 'Blogs', icon: <LiaBlogSolid size={16} /> },
                    { path: '/articles', label: 'Articles', icon: <PiArticleNyTimesBold size={16} /> },
                    { path: '/services', label: 'Services', icon: <AiOutlineAppstore size={16} /> },
                    { path: '/subservices', label: 'Subservices', icon: <BiCube size={16} /> },
                    { path: '/subsubservice', label: 'Sub-Subservice', icon: <FaCubes size={16} /> },
                    { path: '/download', label: 'Pdf Upload', icon: <FaDownload size={16} /> },
                    { path: '/homepage', label: 'Homepage', icon: <FaHome size={16} /> },
                    { path: '/aboutpage', label: 'About Page', icon: <RiInformationLine size={16} /> },
                    { path: '/profile', label: 'Profile', icon: <FaUserAlt size={16} /> },
                    { path: '/our-client', label: 'Our Client', icon: <FaUsers size={16} /> },
                  ].map((item, i) => (
                    <li key={i}>
                      <div
                        onClick={() => {
                          setIsSidebarOpen(false);
                          navigate(item.path);
                        }}
                        className={`${path?.pathname === item.path
                          ? "bg-gray-400 font-semibold"
                          : "text-[#f1e7d6] hover:text-[#a3a231]"}
                          flex items-center cursor-pointer p-2 text-md tracking-wider font-medium rounded-lg mt-4`}>
                        {item.icon}
                        <span className='ml-2'>{item.label}</span>
                      </div>
                    </li>
                  ))}
                </ul>

                {/* <button
                  onClick={handleLogout}
                  className="mt-4 block w-full bg-gradient-to-r from-[#FF3131] to-[#ff9301] text-white font-semibold tracking-wider py-2 px-4 rounded-md text-center hover:bg-red-600 transition duration-300 ease-in-out">
                  Logout
                </button> */}
              </div>
            </motion.div>
          }
        </AnimatePresence>
      </div>
    </div>
  );
};

export default Sidebar;

